import styled from 'styled-components'
import { rem } from 'polished'
import { COMPACT_OTHER_CARD_IMAGE_HEIGHT } from './CarouselOfferCardStyles'
import { mediaQueryUp } from 'components/utils/breakpoint'
import ImageCarousel from 'LuxKit/Carousel/ImageCarousel'
import type { ImageParams } from 'components/Common/ResponsiveImage'
import useImageCarouselHoverPreview from 'hooks/useImageCarouselHoverPreview'
import { useScreenSizeUp } from 'hooks/useScreenSize'

const IMAGE_PARAMS: ImageParams = { width: 320, mobileWidth: '320px', aspectRatio: '16:9', fit: 'center' }

const OfferImageCarouselContainer = styled.div`
  position: absolute;
  inset-block-start: 0;
  inset-inline: 0;
  z-index: 2;
  width: 100%;
  height: ${rem(COMPACT_OTHER_CARD_IMAGE_HEIGHT)};

  ${mediaQueryUp.tablet} {
    height: auto;
    aspect-ratio: 16 / 9;
  }
`

interface Props {
  images: Array<App.Image>
  onClick: () => void
}

function OfferCardImageCarousel({ images, onClick }: Props) {
  const isTabletOrLarger = useScreenSizeUp('tablet')
  const { carouselRef, handleImageChange, handleMouseEnter, handleMouseLeave } = useImageCarouselHoverPreview(images, isTabletOrLarger)

  return <OfferImageCarouselContainer onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onClick={onClick}>
    <ImageCarousel
      carouselRef={carouselRef}
      images={images}
      imageParams={IMAGE_PARAMS}
      onImageChange={handleImageChange}
      arrowBehaviour="interaction-visible"
      arrowStyle="ghost"
    />
  </OfferImageCarouselContainer>
}

export default OfferCardImageCarousel
